import React, { useState, useEffect } from 'react'
import './NavbarDashboard.css'
import { Link as Anchor, useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser, faBook, faImage, faCogs, faAddressBook, faTachometerAlt, faCode, faClipboardList, faQuoteLeft, faMobileAlt, faMapMarkerAlt, faClock, faUtensils, faCog, faBuilding, faBoxes, faMoneyBillWave, faStar, faCalendarAlt, faCreditCard, faChartLine, faHospitalUser, faUserTie } from '@fortawesome/free-solid-svg-icons';
import logo from '../../../images/logo.png'
import Logout from '../Logout/Logout';

export default function Navbar() {
    const location = useLocation();
    const [usuario, setUsuario] = useState({});

    useEffect(() => {
        const cachedUser = sessionStorage.getItem('usuario');
        if (cachedUser) {
            try {
                setUsuario(JSON.parse(cachedUser));
            } catch (e) {
                console.error('Error parsing cached user:', e);
            }
        }
    }, []);

    const hasPermission = (module, action) => {
        if (!usuario || !usuario.rol) return false;
        if (usuario.rol === 'admin') return true;
        if (usuario.rol === 'empleado') {
            let permisos = usuario.permisos;
            if (typeof permisos === 'string') {
                try {
                    permisos = JSON.parse(permisos);
                } catch (e) {
                    permisos = {};
                }
            }
            if (!permisos) return false;
            const modPerm = permisos[module];
            if (modPerm) {
                return !!modPerm[action];
            }
        }
        return false;
    };

    return (

        <div class="navbarDashboard" >
            <Anchor className='logo'>
                <img src={logo} alt="logo" />

            </Anchor>
            <div className='links'>
                {hasPermission('inicio', 'ver') && <Anchor to={`/dashboard`} className={location.pathname === '/dashboard' ? 'activeLink' : ''}><FontAwesomeIcon icon={faHome} /> Inicio</Anchor>}
                {hasPermission('reportes', 'ver') && <Anchor to={`/dashboard/reportes`} className={location.pathname === '/dashboard/reportes' ? 'activeLink' : ''}><FontAwesomeIcon icon={faChartLine} /> Reportes</Anchor>}
                {hasPermission('pacientes', 'ver') && <Anchor to={`/dashboard/pacientes`} className={location.pathname === '/dashboard/pacientes' ? 'activeLink' : ''} ><FontAwesomeIcon icon={faHospitalUser} /> Pacientes</Anchor>}
                {hasPermission('profesionales', 'ver') && <Anchor to={`/dashboard/profesionales`} className={location.pathname === '/dashboard/profesionales' ? 'activeLink' : ''} ><FontAwesomeIcon icon={faUserTie} /> Profesionales</Anchor>}
                {hasPermission('productos', 'ver') && <Anchor to={`/dashboard/productos`} className={location.pathname === '/dashboard/productos' ? 'activeLink' : ''} ><FontAwesomeIcon icon={faBook} /> Productos</Anchor>}
                {hasPermission('pedidos', 'ver') && <Anchor to={`/dashboard/pedidos`} className={location.pathname === '/dashboard/pedidos' ? 'activeLink' : ''}><FontAwesomeIcon icon={faClipboardList} /> Pedidos</Anchor>}
                {hasPermission('inventarios', 'ver') && <Anchor to={`/dashboard/inventarios`} className={location.pathname === '/dashboard/inventarios' ? 'activeLink' : ''}><FontAwesomeIcon icon={faBoxes} /> Inventarios</Anchor>}
                {hasPermission('gastos', 'ver') && <Anchor to={`/dashboard/gastos`} className={location.pathname === '/dashboard/gastos' ? 'activeLink' : ''}><FontAwesomeIcon icon={faMoneyBillWave} /> Gastos</Anchor>}
                {hasPermission('evaluaciones', 'ver') && <Anchor to={`/dashboard/evaluaciones`} className={location.pathname === '/dashboard/evaluaciones' ? 'activeLink' : ''}><FontAwesomeIcon icon={faStar} /> Evaluaciones</Anchor>}
                {hasPermission('medios-pago', 'ver') && <Anchor to={`/dashboard/medios-pago`} className={location.pathname === '/dashboard/medios-pago' ? 'activeLink' : ''}><FontAwesomeIcon icon={faCreditCard} /> Medios de Pago</Anchor>}
                {hasPermission('categorias', 'ver') && <Anchor to={`/dashboard/categorias`} className={location.pathname === '/dashboard/categorias' ? 'activeLink' : ''}><FontAwesomeIcon icon={faTachometerAlt} /> Categorias</Anchor>}
                {hasPermission('banners', 'ver') && <Anchor to={`/dashboard/banners`} className={location.pathname === '/dashboard/banners' ? 'activeLink' : ''}><FontAwesomeIcon icon={faImage} /> Banners</Anchor>}
                {hasPermission('contacto', 'ver') && <Anchor to={`/dashboard/contacto`} className={location.pathname === '/dashboard/contacto' ? 'activeLink' : ''}><FontAwesomeIcon icon={faAddressBook} /> Contacto</Anchor>}
                {hasPermission('usuarios', 'ver') && <Anchor to={`/dashboard/usuarios`} className={location.pathname === '/dashboard/usuarios' ? 'activeLink' : ''}><FontAwesomeIcon icon={faUser} /> Usuarios</Anchor>}
                {hasPermission('codigos', 'ver') && <Anchor to={`/dashboard/codigos`} className={location.pathname === '/dashboard/codigos' ? 'activeLink' : ''}><FontAwesomeIcon icon={faCode} /> Codigos</Anchor>}
                {hasPermission('testimonios', 'ver') && <Anchor to={`/dashboard/testimonios`} className={location.pathname === '/dashboard/testimonios' ? 'activeLink' : ''}><FontAwesomeIcon icon={faQuoteLeft} /> Testimonios</Anchor>}
                {hasPermission('sucursales', 'ver') && <Anchor to={`/dashboard/sucursales`} className={location.pathname === '/dashboard/sucursales' ? 'activeLink' : ''}><FontAwesomeIcon icon={faMapMarkerAlt} /> Sucursales</Anchor>}
                {hasPermission('horarios', 'ver') && <Anchor to={`/dashboard/horarios`} className={location.pathname === '/dashboard/horarios' ? 'activeLink' : ''}><FontAwesomeIcon icon={faClock} /> Horarios</Anchor>}
                {hasPermission('pwa', 'ver') && <Anchor to={`/dashboard/pwa`} className={location.pathname === '/dashboard/pwa' ? 'activeLink' : ''}><FontAwesomeIcon icon={faMobileAlt} /> PWA</Anchor>}
                {hasPermission('configuracion', 'ver') && <Anchor to={`/dashboard/configuracion`} className={location.pathname === '/dashboard/configuracion' ? 'activeLink' : ''}><FontAwesomeIcon icon={faCogs} /> Configuración</Anchor>}
            </div>

            <Logout />

        </div>

    );
}
